$(document).ready(function(){
    $('.top .topText .text').css({y:-50})
    $('.top .topText .text1').css({x:-50})
    $('.top .topText .text').transition({opacity:1,y:0},1000,function(){
        $('.top .topText .text1').transition({opacity:1,x:0},1000)
    })
    

})